<template>
    <div>
        <b-row>
            <b-col md="6" lg="6">
                <b-card no-body bg-variant="default">
                    <div class="card-header">
                        <h5>{{ $t('Component(OtherReplyInformation):information-to-customer') }}</h5>
                    </div>
                    <div class="card-body">
                        <b-form-textarea
                            :placeholder="$t('Component(Placeholder):type-here')"
                            v-model="customerInformation"
                            @input="emit"
                        />
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" lg="6">
                <b-card no-body bg-variant="default">
                    <div class="card-header">
                        <h5>{{ $t('Component(OtherReplyInformation):internal-comment') }}</h5>
                    </div>
                    <div class="card-body">
                        <b-form-textarea
                            v-model="internalComment"
                            :placeholder="$t('Component(Placeholder):type-here')"
                            @input="emit"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {BCard, BRow, BCol, BFormTextarea} from 'bootstrap-vue'

export default {
    components: {
        BRow, BCol, BCard, BFormTextarea,
    },
    props: {
        request: {
            required: true
        },
    },
    data() {
        return {
            internalComment: this.request.otherInformation.internalComment || null,
            customerInformation: this.request.otherInformation.customerInformation || null,
            declarationValidity: null
        };
    },
    methods: {
        emit() {
            this.$emit('input', {
                internalComment: this.internalComment,
                customerInformation: this.customerInformation,
                declarationValidity: this.declarationValidity
            });
        },
        emitValidity() {
            this.$emit('validityChange', true);
        }
    },

    created() {
        this.emitValidity();
    },

    watch: {
        request() {
            if (this.request.otherInformation) {
                this.internalComment = this.request.otherInformation.internalComment;
                this.customerInformation = this.request.otherInformation.customerInformation;
                this.declarationValidity = this.request.otherInformation.declarationValidity;
            }
        }
    }
}
</script>
